var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root-component-container pattern-background-purple" },
    [
      _c(
        "v-container",
        { staticClass: "flex-grow-1", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { staticClass: "justify-center" },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex justify-end",
                  attrs: { cols: "10", md: "6", xl: "4" },
                },
                [_c("AccountOptionsBar", { attrs: { light: "" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "justify-center" },
            [
              _c("v-col", { attrs: { cols: "10", md: "6" } }, [
                _c(
                  "div",
                  {
                    class: {
                      "thin-screen": _vm.$vuetify.breakpoint.width < 350,
                    },
                  },
                  [
                    _c(
                      "p",
                      { staticClass: "text-h5" },
                      [
                        _vm._v("Fast forward "),
                        _c(
                          "router-link",
                          {
                            staticClass: "text-h5 link-light",
                            attrs: { to: _vm.characterRoute },
                          },
                          [_vm._v("character creation")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "justify-center" },
            [
              _c(
                "v-col",
                { attrs: { cols: "10", md: "6" } },
                _vm._l(
                  _vm.day6Resource.poseMarketingVideos,
                  function (data, key) {
                    return _c(
                      "router-link",
                      {
                        key: key,
                        attrs: { to: _vm.characterShareLink(data.shareId) },
                      },
                      [
                        _c(
                          "video",
                          {
                            class: _vm.videoClass(data.fullWidth),
                            attrs: { autoplay: "", loop: "", muted: "" },
                            domProps: { muted: true },
                          },
                          [
                            _c("source", {
                              attrs: {
                                src: _vm.videoSource(data.fileName, "webm"),
                                type: "video/webm",
                              },
                            }),
                            _c("source", {
                              attrs: {
                                src: _vm.videoSource(data.fileName, "mp4"),
                                type: "video/mp4",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  }
                ),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("StaticContentFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }